import { Box, Typography, Select, MenuItem, SelectChangeEvent } from "@mui/material";
import { getFormattedList } from "~/shared/utils/googleConst";
import { IGeoSelect2Props } from "~/shared/types/types";

export const GeoSelect2 = ({ value, onChange }: IGeoSelect2Props) => (
  <Box display="flex" flexDirection="column" gap={0.5}>
    <Typography fontWeight={600} variant="subtitle2">Регион:</Typography>
    <Select
      fullWidth
      displayEmpty
      value={value}
      onChange={onChange}>
      <MenuItem value="">
        <em>Не выбран</em>
      </MenuItem>
      {getFormattedList.map(country => (
        <MenuItem key={country.id} value={country.id}>
          {country.name}
        </MenuItem>
      ))}
    </Select>
  </Box>
)
